import React, { useState, useContext, useEffect } from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import InputLabel from '@material-ui/core/InputLabel'
// import { makeStyles } from '@material-ui/core/styles';

import dayjs from 'dayjs'

import { DateTimePicker } from '@material-ui/pickers'

import _firebaseContext from '../../contexts/firebaseContext'
import _appContext from '../../contexts/appContext'

const initVals = {
    performingAction: true,
    message: '',
}

export default function MessageCreate({ open, handleClose, languageList }) {
    const [performingAction, setPerformingAction] = useState(
        initVals.performingAction
    )
    const [message, setMessage] = useState(initVals.name)
    const [errors, setErrors] = useState({})
    const [locale, setLocale] = useState('ru')

    useEffect(() => {
        resetVals()
    }, [open])

    const firebaseContext = useContext(_firebaseContext)
    const appContext = useContext(_appContext)

    const resetVals = () => {
        setPerformingAction(initVals.performingAction)
        setMessage(initVals.message)
    }

    const _handleClose = () => {
        resetVals()
        handleClose()
    }

    const handleSave = async event => {
        _handleClose()

        const newMessage = {
            message,
        }

        const result = await firebaseContext.createMessage(newMessage, locale)

        if (result.error) {
            // console.log(result);
        } else {
            resetVals()
        }

        appContext.snackbar.showSnackbarMsg(result.message)
    }


    const handleMessageChange = event => {
        const val = event.target.value
        setMessage(event.target.value)
        if (val === '') {
            setErrors({
                ...errors,
                name: 'Наименование стрима не может быть пустым',
            })
        } else {
            setErrors({
                ...errors,
                name: false,
            })
        }
    }

    return (
        <Dialog
            open={open}
            onClose={_handleClose}
            maxWidth="sm"
            fullWidth={true}
        >
            <DialogTitle id="form-dialog-title">Создание сообщения</DialogTitle>
            <DialogContent>
                <InputLabel shrink id="language">
                    Язык
                </InputLabel>
                <Select
                    value={locale}
                    disabled={!performingAction}
                    onChange={(newValue) =>
                        setLocale(newValue.target.value)
                    }
                    labelId="language"
                >
                    {languageList && languageList.map(language => <MenuItem value={language.id} key={language.id}>{language.data.represent}</MenuItem>)}
                </Select>
            </DialogContent>
            <DialogContent>
                <TextField
                    autoFocus
                    disabled={!performingAction}
                    // error={!!(errors && errors.firstName)}
                    fullWidth
                    label="Сообщение"
                    required
                    type="text"
                    value={message}
                    // className={styles.textfield}
                    // onKeyDown={(event) => this.handleKeyDown(event, 'first-name')}
                    onChange={handleMessageChange}
                    multiline
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Отмена
                </Button>
                <Button
                    onClick={handleSave}
                    color="primary"
                    disabled={
                        !!(
                            errors.message ||
                            message === ''
                        )
                    }
                >
                    Сохранить
                </Button>
            </DialogActions>
        </Dialog>
    )
}
